export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full border border-primary-500/20 mb-3">
            联系我们
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 tracking-wide">
            投稿与合作咨询
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2 max-w-xl mx-auto">
            如有影视资源推荐、合作意向或任何问题，欢迎随时联系我们
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 mb-3">
                  <i className="ri-mail-send-line text-xl text-primary-400"></i>
                </div>
                <p className="text-sm font-semibold text-foreground-800 mb-1">投稿邮箱</p>
                <p className="text-xs text-foreground-500">submit@huanggua.tv</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-500/10 mb-3">
                  <i className="ri-customer-service-2-line text-xl text-accent-400"></i>
                </div>
                <p className="text-sm font-semibold text-foreground-800 mb-1">在线客服</p>
                <p className="text-xs text-foreground-500">工作日 9:00-18:00</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-500/10 mb-3">
                  <i className="ri-chat-smile-2-line text-xl text-secondary-400"></i>
                </div>
                <p className="text-sm font-semibold text-foreground-800 mb-1">意见建议</p>
                <p className="text-xs text-foreground-500">feedback@huanggua.tv</p>
              </div>
            </div>

            <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <input
                  type="text"
                  name="name"
                  placeholder="您的称呼"
                  className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200/60 rounded-md text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400/50 transition-colors duration-200"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="电子邮箱"
                  className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200/60 rounded-md text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400/50 transition-colors duration-200"
                />
              </div>
              <input
                type="text"
                name="subject"
                placeholder="主题"
                className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200/60 rounded-md text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400/50 transition-colors duration-200"
              />
              <textarea
                name="message"
                rows={5}
                maxLength={500}
                placeholder="请输入您的留言内容（限500字）"
                className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200/60 rounded-md text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400/50 transition-colors duration-200 resize-none"
              ></textarea>
              <div className="honeypot-field">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <button
                type="submit"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-fill mr-2"></i>发送留言
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}